import type { Interval } from "luxon"

import type { ITableRow } from "../../../models/table"
import { APP_COMPANY_NAME } from "../../../utils/constants"

/**
 * Generates a file name for a report
 *
 * @param reportName - The main title of the report
 * @param dateRange - The start and end dates of the report
 * @params isDataUnderReview - Whether the data is under review or not
 * @returns The file name
 * @example
 * const getReportFileName(
 *   "Gri",
 *   Interval.fromISO("2022-01-01/2022-02-28"),
 *   true)
 */
export const getReportFileName = (
  reportName: string,
  dateRange: Interval | null | undefined,
  isDataReady?: boolean
): string => {
  if (!dateRange?.isValid) {
    return ""
  }

  return `${
    isDataReady ? "" : "(preview) "
  }${APP_COMPANY_NAME} ${reportName} ${dateRange.start?.toISODate()} through ${dateRange.end?.toISODate()}`
}

/**
 * Adds an id to the provided row data so it implements the ITableRow interface
 *
 * @param data - The row data
 * @returns The row data implementing the ITableRow interface
 * @example
 * getReportRows(gresbEnergyData)
 */
export const getReportRows = <TData>(data: TData[]): (TData & ITableRow)[] =>
  data.map((datum, index) => ({
    id: index,
    ...datum,
  }))

export default {
  getReportFileName,
  getReportRows,
}
